// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
// 	production: false,
// 	hmr: false,
// 	 apiUrl: 'http://10.247.7.136/rnd/api/public/api',
// 	cryptoJSKey: 'ENCRYPTEDMNRE&AHASOLAR@2022',
// 	cryptoJSIV: '1234567898765432',
// 	 documentURL: 'http://10.247.7.136/rnd/api/public'
// };

export const environment = {
	production: false,
	hmr: false,
	 apiUrl: 'https://research.mnre.gov.in/api/public/api',
	cryptoJSKey: 'ENCRYPTEDMNRE&AHASOLAR@2022',
	cryptoJSIV: '1234567898765432',
	 documentURL: 'https://research.mnre.gov.in/api/public'
};

// export const environment = {
// 	production: false,
// 	hmr: false,
// 	 apiUrl: 'http://localhost/rndapi/public/api',
// 	cryptoJSKey: 'ENCRYPTEDMNRE&AHASOLAR@2022',
// 	cryptoJSIV: '1234567898765432',
// 	 documentURL: 'http://localhost/rndapi/public'
// };

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
